export default "__VITE_ASSET__xp5fpuR9__"